module.exports = __webpack_public_path__ + "static/media/DisclaimerWarning1.89cff2cd.svg";